import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MembershipEffects } from './store/effects/membership.effects';
import { membershipReducer } from './store/reducers/membership.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('membership', membershipReducer),
    EffectsModule.forFeature([MembershipEffects]),
  ],
})
export class MembershipModule {}
